import React from 'react';
import './MultiSelect.css';

// This file defines the MultiSelect component, which renders a list of checkboxes based on provided options
//Used for selecting/deselecting mutliple items
// The toggleSelection function handles adding or removing items from the selected list
//  and the component also displays the total number of selected items


function MultiSelect({ options, selectedValues, onSelectionChange }) {
    const toggleSelection = (value) => {
        if (selectedValues.includes(value)) {
            onSelectionChange(selectedValues.filter(item => item !== value));
        } else {
            onSelectionChange([...selectedValues, value]);
        }
    };

    return (
        <div>
            <div className="checkbox-container">
                {options.map(option => (
                    <label key={option.value} className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={selectedValues.includes(option.value)}
                            onChange={() => toggleSelection(option.value)}
                        />
                        {option.label}
                    </label>
                ))}
            </div>
            <p>Selected Rooms: {selectedValues.length}</p>
        </div>
    );
}
export default MultiSelect;
